import { AbstractQuery } from 'src/models/query';

export class GetTheColorSchemesQuery extends AbstractQuery {
	cacheable = false;
	name = 'IFS_Core_Query_Queries_GetTheColorSchemesQuery';
	sort = [];
	subscribeForUpdates = false;
	constructor() {
		super();
	}
}

export class GetTheNotificationConfigurationQuery extends AbstractQuery {
	name = 'IFS_Core_Query_Queries_GetTheNotificationConfigurationQuery';
	sort = [];

	constructor() {
		super();
	}
}

export class GetTheEditorStandardFontQuery extends AbstractQuery {
	cacheable = false;
	name = 'IFS_Core_Query_Queries_GetTheEditorStandardFontQuery';
	sort = [];
	subscribeForUpdates = false;

	constructor() {
		super();
	}
}

export class GetTheUserPreferencesQuery extends AbstractQuery {
	cacheable = false;
	name = 'IFS_Core_Query_Queries_GetTheUserPreferencesQuery';
	sort = [];
	subscribeForUpdates = false;

	constructor() {
		super();
	}
}
